export default "__VITE_ASSET__BZgzfUOp__"